"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _progress = require("@react-spectrum/progress");
var _mobxReact = require("mobx-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
require("!style-loader!css-loader!./ProgressView.css");
var _class, _ProgressView;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 201 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let ProgressView = exports.default = (0, _mobxReact.observer)(_class = (_ProgressView = class ProgressView extends _react.default.Component {
  render() {
    let progressText = this.props.progressText;
    let progressClass = "sdk-ProgressView-progress";
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.getConfig().fullScreenLoader) {
      progressClass = "sdk-ProgressView-progressFixed";
    }
    const showUploadFileLoader = appStore.getConfig().showUploadFileLoader;
    if (appStore.getConfig().showSimpleLoader) {
      progressText = "";
    } else if (showUploadFileLoader) {
      progressClass = (0, _classnames.default)([progressClass, "sdk-UploadProgressView-progressBG"]);
    } else {
      let progressBGClass = "sdk-ProgressView-progressBG";
      if (appStore.enableModernViewer && appStore.isLBPreset) {
        progressBGClass = "sdk-ProgressView-progressBG-LB-ModernViewer";
      }
      progressClass = (0, _classnames.default)([progressClass, progressBGClass]);
    }
    let progressTextColor = showUploadFileLoader ? "sdk-ProgressText-dark" : "sdk-ProgressText-light";
    if (appStore.enableModernViewer && appStore.isLBPreset) {
      progressTextColor = "sdk-ProgressText-ModernViewer-LightBox";
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: progressClass
    }, appStore.isInLinePreset ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_progress.ProgressCircle, {
      UNSAFE_className: "sdk-ProgressView-progressWaitInLine",
      "aria-label": "Loading\u2026",
      isIndeterminate: true,
      size: "L"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(["sdk-ProgressView-progressTextInLine", progressTextColor])
    }, progressText)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_progress.ProgressCircle, {
      UNSAFE_className: "sdk-ProgressView-centered",
      "aria-label": "Loading\u2026",
      isIndeterminate: true,
      size: "L"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(["sdk-ProgressView-progressText", progressTextColor])
    }, progressText)));
  }
}, _ProgressView.propTypes = {
  progressText: _propTypes.default.string.isRequired
}, _ProgressView)) || _class;